import React, { ReactNode, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface PortalContentProps {
  id: string
  children: ReactNode
}

export const PortalContent: React.FC<PortalContentProps> = ({
  id,
  children,
}) => {
  const [hostElement, setHostElement] = useState<HTMLElement | null>(null)

  useEffect(() => {
    const host = document.getElementById(id)
    if (host) {
      setHostElement(host)
    }
  }, [id])

  return hostElement ? ReactDOM.createPortal(children, hostElement) : null
}
